module.exports = __webpack_public_path__ + "img/salvador.f889305e.jpg";